"use client";
import React from "react";
import { Input as AntdInput } from "antd";
import { useField } from "providers/FormProvider";
import cx from "classnames";

interface InputProps {
  name: string;
  label?: string;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  [key: string]: unknown;
}

const Input: React.FC<InputProps> = ({
  name,
  label,
  type = "text",
  placeholder,
  disabled = false,
  className,
  ...props
}) => {
  const [field, meta] = useField(name);

  return (
    <div className={cx("flex flex-col gap-1", className)}>
      {label && (
        <label htmlFor={name} className="text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <AntdInput
        id={name}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        className={className}
        status={meta.touched && meta.error ? "error" : ""}
        {...field}
        {...props}
      />
      {meta.touched && meta.error && (
        <span className="text-xs text-red-500">{meta.error}</span>
      )}
    </div>
  );
};

export default Input;
